<template>
  <div class="simple-list-wrapper">
    <!-- eslint-disable -->
    <!-- TOOLBAR -->
    <div v-if="!clean" class="table-toolbar">
      <div class="toolbar-start">
        <h1 class="sl-title">{{ this.title }}</h1>
        <md-button v-if="buttonAction && buttonText" class="md-raised md-primary ml-20 top-action-btn" v-on:click="newElement">{{ buttonText }}</md-button>
        <md-button id="moreData" v-if="title === options.Lang.Aktive_Vorgänge || title === options.Lang.poi" disabled v-on:click="addData" class="md-primary md-raised float_right ml-20">
          {{ options.Lang.mehrDaten }}
          <span v-if="showTripCount">({{ tripCount }})</span>
        </md-button>
        <md-button id="lessData" v-if="title !== 'Auswertung'" disabled v-on:click="rmvData" class="md-primary md-raised float_right ml-20">
          {{ options.Lang.neuLaden }}
        </md-button>
      </div>
      <div class="toolbar-end">
        <div v-if="showCreateNewClient" class="inline_block mr-30">
          <md-button class="md-raised md-primary small_btn" v-on:click="alert()">
            <md-icon>add</md-icon>
          </md-button>
          <md-tooltip md-delay="1000">{{ options.Lang.Neuen_Kunden_anlegen }}</md-tooltip>
        </div>
        <div v-if="!hideSearch && !isAuswertung" class="toolbar-search">
          <span class="search-result-count" :style="{ visibility: search && search.trim() !== '' && searched ? 'visible' : 'hidden' }">
            {{ searched ? searched.length : 0 }} {{ searched && searched.length === 1 ? options.Lang.Ergebnis : options.Lang.Ergebnisse }}
          </span>
          <div class="search-bar">
            <md-icon class="search-bar-icon">search</md-icon>
            <input
              id="search_input_trip_list"
              class="search-bar-input"
              type="text"
              :placeholder="options.Lang.Suche"
              v-model="search"
              @keyup.enter="searchThis"
            />
            <md-icon class="search-bar-clear" :style="{ visibility: search ? 'visible' : 'hidden' }" @click.native="clearSearch">close</md-icon>
          </div>
          <div v-if="options.currentRoute === 'Trips'" class="search-help-wrapper">
            <md-icon class="search-help-icon" @click.native="showSearchHelp = !showSearchHelp">help_outline</md-icon>
            <div v-if="showSearchHelp" class="search-help-popup">
              <div class="search-help-header">
                <span>{{ $t('search_help_title') }}</span>
                <md-icon class="search-help-close" @click.native="showSearchHelp = false">close</md-icon>
              </div>
              <div class="search-help-body">
                <p>{{ $t('search_help_text') }}</p>
                <table class="search-help-table">
                  <tr>
                    <td class="search-help-example">Explorer</td>
                    <td>{{ $t('search_help_ex1') }}</td>
                  </tr>
                  <tr>
                    <td class="search-help-example">Smith</td>
                    <td>{{ $t('search_help_ex2') }}</td>
                  </tr>
                  <tr>
                    <td class="search-help-example">confirmed</td>
                    <td>{{ $t('search_help_ex3') }}</td>
                  </tr>
                  <tr>
                    <td class="search-help-example">Smith, 04 Sep 2026</td>
                    <td>{{ $t('search_help_ex4') }}</td>
                  </tr>
                  <tr>
                    <td class="search-help-example">4 Sep 2026 - 14 Sep 2026</td>
                    <td>{{ $t('search_help_ex5') }}</td>
                  </tr>
                  <tr>
                    <td class="search-help-example">Explorer, 4 Sep 2026 - 14 Sep 2026</td>
                    <td>{{ $t('search_help_ex6') }}</td>
                  </tr>
                </table>
                <p class="search-help-formats">{{ $t('search_help_formats') }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="isAuswertung" class="toolbar-auswertung">
        <div style="display: flex; flex-direction: column; min-width: 140px;">
          <label>Startdatum</label>
          <md-datepicker v-model="selectedDate1"></md-datepicker>
        </div>
        <div style="display: flex; flex-direction: column; min-width: 140px;">
          <label>Enddatum</label>
          <md-datepicker v-model="selectedDate2"></md-datepicker>
        </div>
        <div style="display: flex; flex-direction: column; min-width: 150px;">
          <md-field style="padding-top: 20px; margin: 0;" class="md-focused">
            <md-select v-model="selectedBrand" name="sprache" id="sprache">
              <md-option value="alle">{{ options.Lang.alle }}</md-option>
              <md-option v-for="(brand, index) in brands" :key="'indexBrandSelect'+index" :value="brand.id">
                {{ brand.adresse }}
              </md-option>
            </md-select>
          </md-field>
        </div>
        <div style="display: flex; flex-direction: column; padding-top: 20px;">
          <md-button class="md-raised md-primary" @click="applyAuswertungFilter()" :disabled="!canApplyFilter">
            {{ options.Lang.Anwenden || 'Anwenden' }}
          </md-button>
        </div>
        <div style="display: flex; flex-direction: column; padding-top: 20px;">
          <md-button class="md-raised md-primary" @click="downloadCSV()" :disabled="!searched || searched.length === 0">
            <md-icon>download</md-icon>
            {{ options.Lang.Als_CSV_herunterladen || 'CSV' }}
          </md-button>
        </div>
      </div>
    </div>

    <!-- TABLE CONTAINER -->
    <div class="table-container">
      <div v-if="isSearching" class="search-overlay">
        <div class="custom-spinner"></div>
      </div>
      <!-- Empty state -->
      <div v-if="loaded && (!searched || searched.length === 0)" class="table-empty">
        {{ emptyState }}
      </div>

      <table v-else-if="loaded" class="sl-table">
        <thead>
          <tr>
            <th
              v-for="col in visibleColumns"
              :key="'th-'+col"
              @click="sortBy(col)"
              class="sl-th"
              :class="{ 'sl-sorted': currentSort === col }"
            >
              <span class="sl-th-label">
                {{ $t(col) }}
                <span v-if="currentSort === col" class="sl-sort-icon">
                  {{ currentSortOrder === 'asc' ? '▲' : '▼' }}
                </span>
              </span>
            </th>
            <th v-if="!isAuswertung && actions.length > 0" class="sl-th sl-th-actions" :class="{ 'sl-th-actions-collapsed': actionsCollapsed, 'sl-th-actions-few': actions.length <= 2 }" @click.stop="">
              <span class="actions-header-content">
                <span class="actions-header-text" :class="{ 'actions-header-text-hidden': actionsCollapsed }">{{ $t('actions') }}</span>
                <md-button class="md-icon-button actions-toggle-btn" @click.stop="toggleActionsCollapsed()">
                  <md-icon>{{ actionsCollapsed ? 'chevron_left' : 'chevron_right' }}</md-icon>
                </md-button>
              </span>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(item, rowIdx) in searched"
            :key="'row-'+rowIdx"
            class="sl-row"
            :class="{
              'booking-bar-booked': item.booking_state === 'BookingCompleted',
              'booking-bar-cancelled': item.booking_state === 'Cancelled',
              'booking-bar-planning': item.booking_state === 'Planning',
              'sl-row-menu-open': openMenuIdx === rowIdx
            }"
            @click="onRowClick(item)"
          >
            <td
              v-for="col in visibleColumns"
              :key="'td-'+rowIdx+'-'+col"
              class="sl-td"
            >
              <span v-if="col === 'status'" :class="'table_cell_status status_'+ item[col]"></span>
              <span v-else-if="col === 'client_name'" :title="item.lastname + ' ' + item.firstname">{{ prepareTableCellContent(item.lastname + ' ' + item.firstname, 10) }}</span>
              <span v-else-if="col === 'sales_name'">{{ item.sales_lastname }} {{ item.sales_firstname }}</span>
              <span v-else-if="col === 'tools'" v-html="item[col]"></span>
              <span v-else-if="col === 'categoryName'" class="catCell">{{ item[col] }}</span>
              <span v-else-if="col === 'trip_date'" :title="item[col]" class="dateCell">{{ item[col] }}</span>
              <span v-else-if="col === 'link'"><a :href="item[col]" target="_blank">{{ item[col] }}</a></span>
              <span v-else-if="col === 'supersuper'" :style="item[col] === 1 ? 'color: green; font-weight: bold;' : 'color: red; font-weight: bold;'">{{ item[col] === 1 ? '✓' : '✗' }}</span>
              <span v-else-if="col === 'trips_isolated'" :style="item[col] === 1 ? 'color: green; font-weight: bold;' : 'color: red; font-weight: bold;'">{{ item[col] === 1 ? '✓' : '✗' }}</span>
              <span v-else-if="col === 'totp_enabled'" :style="item[col] === 1 ? 'color: green; font-weight: bold;' : 'color: red; font-weight: bold;'">{{ item[col] === 1 ? '✓' : '✗' }}</span>
              <span v-else-if="col === 'booking_state' && item[col]" class="booking-state-badge" :class="'bs-' + bookingStateClass(item[col])">{{ formatBookingState(item[col]) }}</span>
              <span v-else-if="col === 'booking_state' && !item[col]">–</span>
              <!-- Ang-Nr (offer id) + "copy the customer's offer link": the client URL
                   WITHOUT the agent token (lands on the customer login) is copied to the
                   clipboard; the tooltip shows the login code that goes with it.
                   Enabled per list via the offerLink prop (Trips). -->
              <span v-else-if="col === 'offer_id' && offerLink" class="offer-id-cell">
                <CustomTooltip :text="loginCodeTooltip(item)">
                  <!-- after a click the icon turns into a green tick for a few seconds
                       (cross-fade + scale), then back to the copy icon -->
                  <transition name="offer-copy" mode="out-in">
                    <img v-if="copiedOfferId === item.offer_id" key="copied" src="@/assets/images/icons/check_green.svg" class="offer-open-icon offer-open-icon--copied" :alt="options.Lang.trip_copy_client_link" />
                    <img v-else key="copy" src="@/assets/images/icons/open_in_new.svg" class="offer-open-icon" :alt="options.Lang.trip_copy_client_link" @click.stop="copyClientOfferLink(item)" />
                  </transition>
                </CustomTooltip>
                <span class="offer-id-text">{{ item[col] }}</span>
              </span>
              <span v-else-if="col === 'nezasa_id'" class="nezasa-id-cell" :title="item[col]">
                <span class="nezasa-id-text">{{ item[col] }}</span>
                <!-- same confirmation as the Ang-Nr cell, but a plain green tick -->
                <transition name="offer-copy" mode="out-in">
                  <img v-if="copiedNezasaId === item[col]" key="copied" src="@/assets/images/icons/check_green.svg" class="copy-icon-img copy-icon-img--copied" alt="" />
                  <img v-else key="copy" src="@/assets/images/icons/copy.svg" class="copy-icon-img" @click.stop="copyNezasaId(item[col])" />
                </transition>
              </span>
              <span v-else-if="col === 'checkout_url'" class="nezasa-id-cell" :title="item[col]">
                <a :href="item[col]" target="_blank" class="checkout-url-text">{{ prepareTableCellContent(item[col], wide ? wide : 20) }}</a>
                <img src="@/assets/images/icons/copy.svg" class="copy-icon-img" @click.stop="copyToClipboard(item[col])" />
              </span>
              <span v-else :title="item[col]">{{ prepareTableCellContent(item[col], wide ? wide : 12) }}</span>
            </td>

            <!-- ACTION COLUMN - expanded by default, collapsible via toggle -->
            <td v-if="!isAuswertung && actions.length > 0" class="sl-td sl-td-actions" :class="{ 'sl-td-actions-collapsed': actionsCollapsed, 'sl-td-actions-few': actions.length <= 2 }">
              <!-- EXPANDED VIEW (default) - show all action icons inline -->
              <div class="actions-expanded" :class="{ 'actions-content-hidden': actionsCollapsed }">
                <span
                  v-for="(action, aIdx) in filteredActions(item)"
                  :key="'action-exp-'+aIdx"
                  class="action-inline-item"
                  :class="{
                    'disabled light': action.showCheckValue && action.showCheckValue.includes(item[action.showCheckColumn]),
                    'checked': action.classCheckColumn && action.classCheckValue && item[action.classCheckColumn] === action.classCheckValue
                  }"
                  @click.stop="onActionClick(action, item, $event)"
                  :title="action.title"
                >
                  <span v-if="action.text" class="action-text-icon">{{ action.text }}</span>
                  <template v-else-if="action.icon !== null && Array.isArray(action.icon)">
                    <span class="double_icon relative">
                      <md-button class="md-button" :class="(item[action.classCheckColumn] === action.classCheckValue ? action.classCheckClass : '')">
                        <span
                          v-for="(iconItem, iconIdx) in action.icon"
                          :key="'aei-'+aIdx+'-'+iconIdx"
                          style="display:inline-block"
                        >
                          <template v-if="action.svg">
                            <template v-if="getIconUrl(iconItem).type === 'html'">
                              <span class="svg-icon inline-svg" v-html="getIconUrl(iconItem).value"></span>
                            </template>
                            <template v-else>
                              <img :src="getIconUrl(iconItem).value" class="svg-icon" :alt="action.title" />
                            </template>
                          </template>
                          <span v-else :class="iconItem + ' md-icon'"></span>
                        </span>
                        <md-tooltip md-delay="1000">{{ action.title }}</md-tooltip>
                      </md-button>
                    </span>
                  </template>
                  <template v-else-if="action.icon !== null && !Array.isArray(action.icon)">
                    <md-button class="md-icon-button action_color"
                      :class="(action.classCheckColumn && action.classCheckValue && item[action.classCheckColumn] === action.classCheckValue ? 'checked':'')">
                      <template v-if="action.svg">
                        <img v-if="action.greenIcon && action.greenCheckColumn && item[action.greenCheckColumn]" :src="getIconUrl(action.greenIcon).value" class="svg-icon" :alt="action.title" />
                        <img v-else :src="getIconUrl(action.icon, item.titelimg).value" class="svg-icon" :class="{ 'svg-icon-green': action.greenCheckColumn && !action.greenIcon && item[action.greenCheckColumn] }" :alt="action.title" />
                      </template>
                      <md-icon v-else-if="(action.action === 'editUser' || action.action === 'editSupplier') || (action.iconMaterial) || (action.action === 'editPOI')"
                        :style="action.icon === 'add_photo_alternate' && item.titelimg == null ? 'color: red !important;' : ''">
                        {{ action.icon }}
                      </md-icon>
                      <span v-else :class="action.colorClass + ' ' + action.icon + ' md-icon'"></span>
                      <span :class="item[action.classCheckColumn]"></span>
                      <md-tooltip md-delay="1000">{{ action.title }}</md-tooltip>
                    </md-button>
                  </template>
                </span>
              </div>

              <!-- COLLAPSED VIEW - popup menu via three-dot button -->
              <div class="action-menu-wrapper" :class="{ 'action-menu-visible': actionsCollapsed }">
                <md-button class="md-icon-button action-trigger" :ref="'trigger-'+rowIdx" @click.stop="toggleActionMenu(rowIdx, $event)">
                  <md-icon>more_vert</md-icon>
                </md-button>
                <transition name="menu-fade">
                  <div v-if="openMenuIdx === rowIdx" class="action-popup" :class="{ 'action-popup-up': menuDirection === 'up' }" v-click-outside="closeActionMenu">
                    <div v-if="item.nezasa_id || item.offer_id || item.id" class="action-popup-header">
                      {{ item.nezasa_id ? 'Nezasa ID: ' + item.nezasa_id : '#' + (item.offer_id || item.id) }}
                    </div>
                    <div
                      v-for="(action, aIdx) in filteredActionsPopup(item)"
                      :key="'action-pop-'+aIdx"
                      class="action-popup-item"
                      :class="{ 'disabled': action.showCheckValue && action.showCheckValue.includes(item[action.showCheckColumn]) }"
                      @click.stop="onActionClick(action, item, $event)"
                    >
                      <template v-if="action.icon !== null && Array.isArray(action.icon)">
                        <span class="action-popup-icons">
                          <template v-for="(iconItem, iconIdx) in action.icon">
                            <template v-if="action.svg">
                              <template v-if="getIconUrl(iconItem).type === 'html'">
                                <span :key="'api-'+iconIdx" class="svg-icon inline-svg" v-html="getIconUrl(iconItem).value"></span>
                              </template>
                              <template v-else>
                                <img :key="'api-'+iconIdx" :src="getIconUrl(iconItem).value" class="svg-icon" :alt="action.title" />
                              </template>
                            </template>
                            <span v-else :key="'api-'+iconIdx" :class="iconItem + ' md-icon'" style="font-size: 18px;"></span>
                          </template>
                        </span>
                      </template>
                      <template v-else-if="action.icon !== null && !Array.isArray(action.icon)">
                        <template v-if="action.svg">
                          <img v-if="action.greenIcon && action.greenCheckColumn && item[action.greenCheckColumn]" :src="getIconUrl(action.greenIcon).value" class="svg-icon" :alt="action.title" />
                          <img v-else :src="getIconUrl(action.icon, item.titelimg).value" class="svg-icon" :class="{ 'svg-icon-green': action.greenCheckColumn && !action.greenIcon && item[action.greenCheckColumn] }" :alt="action.title" />
                        </template>
                        <md-icon v-else-if="action.iconMaterial || action.action === 'editUser' || action.action === 'editSupplier' || action.action === 'editPOI'"
                          :style="action.icon === 'add_photo_alternate' && item.titelimg == null ? 'color: red !important;' : ''"
                          style="font-size: 18px;">
                          {{ action.icon }}
                        </md-icon>
                        <span v-else :class="action.colorClass + ' ' + action.icon + ' md-icon'" style="font-size: 18px;"></span>
                      </template>
                      <span class="action-popup-label">{{ action.title }}</span>
                    </div>
                  </div>
                </transition>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <Success :options="options"></Success>
    <ConfirmListDelete
      :options="options"
      :showDialog="showDeleteConfirmation"
      :confirmMessage="options.Lang.passolution.confirm_delete"
      :itemToDelete="itemToDelete"
      @confirm-delete="confirmDeleteLink"
      @cancel-delete="cancelDeleteLink"
    />
  </div>
</template>

<script>
import * as moment from 'moment';
import Success from '../../components/dialogs/Success.vue'
import ConfirmListDelete from '../dialogs/ConfirmListDelete.vue'
import CustomTooltip from '../parts/CustomTooltip.vue'

export default {
  name: 'SimpleList',
  components: {
    Success,
    ConfirmListDelete,
    CustomTooltip
  },
  directives: {
    'click-outside': {
      bind(el, binding) {
        el.__clickOutsideHandler = function (event) {
          if (!(el === event.target || el.contains(event.target))) {
            binding.value(event);
          }
        };
        document.addEventListener('click', el.__clickOutsideHandler);
      },
      unbind(el) {
        document.removeEventListener('click', el.__clickOutsideHandler);
        delete el.__clickOutsideHandler;
      }
    }
  },
  computed: {
    canApplyFilter() {
      const hasDate1 = this.selectedDate1 != null && this.selectedDate1 !== '';
      const hasDate2 = this.selectedDate2 != null && this.selectedDate2 !== '';
      const hasBrand = this.selectedBrand != null && this.selectedBrand !== '';
      return hasDate1 && hasDate2 && hasBrand;
    },
    localCurrentTrip: {
      get() {
        return this.options.currentTrip
      },
      set(value) {
        this.options.currentTrip = value
      }
    },
    month() {
      return [
        'Januar', 'Februar', 'März', 'April',
        'Mai', 'Juni', 'Juli', 'August',
        'September', 'Oktober', 'November', 'Dezember',
      ]
    },
    visibleColumns() {
      if (!this.searched || this.searched.length === 0) return [];
      const allKeys = Object.keys(this.searched[0]);
      if (this.cols && this.cols.length > 0) {
        return this.cols.filter(key => allKeys.includes(key) && !this.hideCols.includes(key));
      }
      return allKeys.filter(key => !this.hideCols.includes(key));
    }
  },
  props: {
    options: {
      type: Object,
      required: true
    },
    brands: {},
    isClients: {
      type: Boolean
    },
    defaultCount: {
      type: Number
    },
    isTrips: {
      type: Boolean
    },
    hideSearch: {
      type: Boolean,
    },
    serverside: {
      type: Boolean,
    },
    clientSource: {
      type: String,
    },
    tripsSource: {
      type: String,
    },
    showCreateNewClient: {
      type: Boolean,
    },
    showCreateNewTrips: {
      type: Boolean,
    },
    data: {
      required: true
    },
    title: {
      type: String,
      required: true
    },
    clean: {
      type: Boolean
    },
    actions: {
      type: Array,
    },
    hideCols: {
      type: Array,
    },
    cols: {
      type: Array,
    },
    // Trips list: show the "open in client view" icon in the Ang-Nr cell
    offerLink: {
      type: Boolean,
      default: false
    },
    emptyState: {
      type: String,
      required: true
    },
    helperTable: {
      type: Boolean
    },
    helperMaxClients: {
      type: Number
    },
    buttonText: {
      type: String,
    },
    buttonAction: {
      type: String,
    },
    wide: {
      type: Number,
    },
    selectAction: {
      type: String
    },
    initialDate1: {
      type: String,
      default: null
    },
    initialDate2: {
      type: String,
      default: null
    },
    initialBrand: {
      type: [String, Number],
      default: 'alle'
    },
    isAuswertung: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      // Ang-Nr cell: offer whose customer link was just copied (green tick shown)
      copiedOfferId: null,
      copiedOfferTimer: null,
      // Nezasa ID cell: id just copied (green tick shown)
      copiedNezasaId: null,
      copiedNezasaTimer: null,
      clearInvoice: null,
      selectedDate1: this.initialDate1,
      selectedDate2: this.initialDate2,
      selectedBrand: this.initialBrand,
      tripsAuswertung: [],
      tableLength: this.defaultCount,
      currentSort: "id",
      searchTimeout: null,
      isSearching: false,
      currentSortOrder: "desc",
      dataLoaded: 1,
      tripCount: 0,
      showTripCount: false,
      search: null,
      searched: [],
      tableData: this.data,
      originalTableData: null,
      filteredTableData: null,
      clientToAdd: {},
      clientsToDelete: {},
      amounts: [],
      keyHelper: this.getRandomInt(1, 10000),
      searchMonth: 'Monat',
      searchYear: 'Jahr',
      loaded: false,
      brandings: null,
      allowedUserBranding: null,
      matchedBrand: [],
      showDeleteConfirmation: false,
      itemToDelete: null,
      openMenuIdx: null,
      menuDirection: 'down',
      popupStyle: {},
      actionsCollapsed: false,
      showSearchHelp: false
    }
  },
  async mounted() {
    // Restore actions collapsed state for Trips and TripsArchived
    if (this.options.currentRoute === 'Trips' || this.options.currentRoute === 'TripsArchived') {
      const saved = localStorage.getItem('tripsActionsCollapsed');
      if (saved !== null) {
        this.actionsCollapsed = saved === 'true';
      }
    }
    const countDataExists = sessionStorage.getItem("trip_count") !== null;
    if (this.isAuswertung) {
      this.searched = []
    }
    let moreDataBtn = document.getElementById("moreData")
    let lessDataBtn = document.getElementById("lessData")

    if (moreDataBtn) {
      moreDataBtn.disabled = false;
    }
    if (lessDataBtn) {
      lessDataBtn.disabled = true;
    }
    if (countDataExists) {
      lessDataBtn.disabled = false;
    }
    const trip_search = sessionStorage.getItem("trip_search");
    if (trip_search) {
      await this.loadCurrentState()
    }
    if (this.options.currentRoute === 'Trips') {
      const data_number = sessionStorage.getItem('more_data_number');
      if (data_number && !isNaN(data_number) && parseInt(data_number) > 19) {
        this.tripCount = data_number;
        this.showTripCount = true;
      }
    }
  },
  watch: {
    'options.currentRoute'(newRoute, oldRoute) {
      if (newRoute !== oldRoute) {
        this.search = null;
        this.showSearchHelp = false;
      }
    },
    search(newVal) {
      if (!newVal || newVal.trim() === '') {
        this.clearSearchResults();
      }
    },
    initialDate1: {
      handler(newValue) {
        if (newValue !== null) {
          this.selectedDate1 = newValue;
        }
      },
      immediate: true
    },
    initialDate2: {
      handler(newValue) {
        if (newValue !== null) {
          this.selectedDate2 = newValue;
        }
      },
      immediate: true
    },
    initialBrand: {
      handler(newValue) {
        if (newValue !== null) {
          this.selectedBrand = newValue;
        }
      },
      immediate: true
    },
    data: {
      handler(newValue) {
        this.$i18n.locale = this.options.Lang.tableLang || 'en'
        if (newValue && newValue[0]) {
          let self = this;
          self.loaded = false;
          self.tableData = newValue;
          self.searched = self.title === self.options.Lang.Aktive_Vorgänge ?
            newValue.slice(0, self.options.defaultCount) :
            self.title === self.options.Lang.poi ?
              newValue.slice(0, self.options.defaultCount) :
              newValue.slice(0, 200);
          self.loaded = true;
          self.dataLoaded = 1;
        } else if (Array.isArray(newValue) && newValue.length === 0) {
          this.tableData = [];
          this.searched = [];
          this.loaded = true;
        }
      },
      deep: true,
      immediate: true,
    }
  },
  beforeDestroy() {
    clearTimeout(this.copiedOfferTimer);
    clearTimeout(this.copiedNezasaTimer);
  },
  methods: {
    sortBy(col) {
      if (this.currentSort === col) {
        this.currentSortOrder = this.currentSortOrder === 'asc' ? 'desc' : 'asc';
      } else {
        this.currentSort = col;
        this.currentSortOrder = 'asc';
      }
      this.customSort();
    },
    toggleActionsCollapsed() {
      this.actionsCollapsed = !this.actionsCollapsed;
      if (this.options.currentRoute === 'Trips' || this.options.currentRoute === 'TripsArchived') {
        localStorage.setItem('tripsActionsCollapsed', this.actionsCollapsed);
      }
    },
    toggleActionMenu(idx, event) {
      if (this.openMenuIdx === idx) {
        this.openMenuIdx = null;
        return;
      }
      const btn = event.currentTarget;
      const btnRect = btn.getBoundingClientRect();
      const container = this.$el.querySelector('.table-container');
      const containerRect = container.getBoundingClientRect();
      const spaceBelow = containerRect.bottom - btnRect.bottom;
      const spaceAbove = btnRect.top - containerRect.top;
      const estimatedMenuHeight = (this.actions.length * 36) + 40;
      this.menuDirection = (spaceBelow < estimatedMenuHeight && spaceAbove > spaceBelow) ? 'up' : 'down';
      this.openMenuIdx = idx;
    },
    closeActionMenu() {
      this.openMenuIdx = null;
    },
    filteredActions(item) {
      return this.actions.filter(a => {
        if (a.action === 'addClientAmount') return false;
        if (a.invoice_check && !item.is_invoice && item.is_invoice !== 0) return false;
        return true;
      });
    },
    filteredActionsPopup(item) {
      return this.actions.filter(a => {
        if (a.action === 'addClientAmount') return false;
        if (a.invoice_check && !item.is_invoice && item.is_invoice !== 0) return false;
        if (a.text && !a.icon) return false;
        return true;
      });
    },
    onActionClick(action, item, event) {
      if (action.showCheckValue && action.showCheckValue.includes(item[action.showCheckColumn])) return;
      this.openMenuIdx = null;
      this.tableAction(action.action, item, event);
    },
    onRowClick(item) {
      // Keep single-row selection behavior
    },
    formatBookingState(state) {
      const labels = {
        'BookingInitiated': 'Booking Initiated',
        'BookingInProgress': 'Booking In Progress',
        'BookingRequested': 'Booking Requested',
        'BookingCompleted': 'Booking Completed',
        'BookingFailed': 'Booking Failed',
        'BookingChangeInitiated': 'Change Initiated',
        'BookingChangeInProgress': 'Change In Progress',
        'BookingChangeRequested': 'Change Requested',
        'BookingChangeCompleted': 'Change Completed',
        'CancellationInitiated': 'Cancellation Initiated',
        'CancellationInProgress': 'Cancellation In Progress',
        'CancellationRequested': 'Cancellation Requested',
        'CancellationCompleted': 'Cancellation Completed',
        'Cancelled': 'Cancelled',
        'Discarded': 'Discarded',
        'Planning': 'Planning',
      };
      return labels[state] || state;
    },
    bookingStateClass(state) {
      const map = {
        'BookingInitiated': 'booking-initiated',
        'BookingInProgress': 'booking-inprogress',
        'BookingRequested': 'booking-requested',
        'BookingCompleted': 'booking-completed',
        'BookingFailed': 'booking-failed',
        'BookingChangeInitiated': 'change-initiated',
        'BookingChangeInProgress': 'change-inprogress',
        'BookingChangeRequested': 'change-requested',
        'BookingChangeCompleted': 'change-completed',
        'CancellationInitiated': 'cancel-initiated',
        'CancellationInProgress': 'cancel-inprogress',
        'CancellationRequested': 'cancel-requested',
        'CancellationCompleted': 'cancel-completed',
        'Cancelled': 'cancelled',
        'Discarded': 'discarded',
        'Planning': 'planning',
      };
      return map[state] || 'unknown';
    },
    copyToClipboard(text) {
      navigator.clipboard.writeText(text);
      const icon = event.currentTarget;
      icon.classList.add('copy-animate');
      setTimeout(() => {
        icon.classList.remove('copy-animate');
      }, 300);
    },
    downloadCSV() {
      if (!this.searched || this.searched.length === 0) {
        return;
      }

      let brandingName = 'alle';
      if (this.selectedBrand && this.selectedBrand !== 'alle' && this.brands) {
        const brand = this.brands.find(b => b.id === this.selectedBrand);
        if (brand) {
          brandingName = brand.adresse || 'alle';
        }
      }

      const formatDateForFilename = (date) => {
        if (!date) return '';
        const d = new Date(date);
        const day = String(d.getDate()).padStart(2, '0');
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const year = d.getFullYear();
        return `${day}-${month}-${year}`;
      };
      const startDateStr = formatDateForFilename(this.selectedDate1);
      const endDateStr = formatDateForFilename(this.selectedDate2);

      const visibleCols = this.cols.filter(col => !this.hideCols.includes(col));
      const headers = visibleCols.map(col => {
        return this.$t(col) || col;
      });

      const rows = this.searched.map(item => {
        return visibleCols.map(col => {
          let value = item[col];
          if (value === null || value === undefined) {
            value = '';
          }
          value = String(value).replace(/"/g, '""');
          if (value.includes(',') || value.includes('\n') || value.includes('"')) {
            value = `"${value}"`;
          }
          return value;
        });
      });

      const csvContent = [
        headers.join(','),
        ...rows.map(row => row.join(','))
      ].join('\n');

      const blob = new Blob(['\ufeff' + csvContent], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      const url = URL.createObjectURL(blob);

      const auswertungTranslation = this.options.Lang.Auswertung || 'Auswertung';
      const safeAuswertung = auswertungTranslation.replace(/[^a-zA-Z0-9äöüÄÖÜß]/g, '_');
      const safeBrandingName = brandingName.replace(/[^a-zA-Z0-9äöüÄÖÜß]/g, '_');

      const filename = `${safeAuswertung}_${startDateStr}_${endDateStr}_${safeBrandingName}.csv`;

      link.setAttribute('href', url);
      link.setAttribute('download', filename);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    },
    getIconUrl(name, titleImg = false) {
      const normalized = String(name || '').toLowerCase();

      if (normalized === 'addimage' || normalized === 'addimage.png') {
        let svg;
        const wantsRed = titleImg === null;
        if (wantsRed) {
          svg = require('@/assets/images/icons/addImageRed.png');
        } else {
          svg = require('@/assets/images/icons/addImage.png');
        }
        return { type: 'url', value: svg };
      }

      try {
        const src = require(`@/assets/images/icons/${name}`);
        return { type: 'url', value: src };
      } catch (e) {
        if (typeof name === 'string' && name.trim().startsWith('<svg')) {
          return { type: 'html', value: name };
        }
        return { type: 'url', value: name };
      }
    },
    selectBrand() {
      // Removed auto-trigger, now handled by applyAuswertungFilter button
    },
    applyAuswertungFilter() {
      if (this.selectedBrand != null && this.selectedDate1 != null && this.selectedDate2 != null) {
        const startDate = this.selectedDate1;
        const endDate = this.selectedDate2;
        const formattedStartDate = moment(startDate).startOf('day').format('YYYY-MM-DD HH:mm:ss');
        const formattedEndDate = moment(endDate).endOf('day').format('YYYY-MM-DD HH:mm:ss');
        this.$emit('updateData', {
          brand: this.selectedBrand,
          date1: formattedStartDate,
          date2: formattedEndDate,
          rawDate1: startDate,
          rawDate2: endDate
        });
      }
    },
    async checkAuswertung() {
      if (this.selectedBrand != null && this.selectedDate1 != null && this.selectedDate2 != null) {
        const startDate = this.selectedDate1;
        const endDate = this.selectedDate2;
        const formattedStartDate = moment(startDate).startOf('day').format('YYYY-MM-DD HH:mm:ss');
        const formattedEndDate = moment(endDate).endOf('day').format('YYYY-MM-DD HH:mm:ss');
        this.selectedDate1 = formattedStartDate;
        this.selectedDate2 = formattedEndDate;
        this.$emit('updateData', {
          brand: this.selectedBrand,
          date1: this.selectedDate1,
          date2: this.selectedDate2
        });
      }
    },
    checklessDataButton() {
      if (this.searched.length >= this.tableLength) {
        let lessDataBtn = document.getElementById("lessData")
        if (lessDataBtn) {
          document.getElementById("lessData").disabled = false;
        }
      }
    },
    customSort() {
      let self = this;
      if (self.serverside) {
        self.options.isUploading = true;
        let where = '';
        if ((self.searchMonth || self.searchMonth === 0) && self.searchMonth !== 'Monat') {
          where = ' AND (MONTH(clients.birthday) = ' + (self.month.indexOf(self.searchMonth) + 1) + ' OR  MONTH(clients.partner_birthday) = ' + (self.month.indexOf(self.searchMonth) + 1) + ')';
          if (self.searchYear !== 'Jahr') {
            where += ' AND YEAR(clients.birthday) = ' + self.searchYear;
          }
        } else if (self.searchYear && self.searchYear !== 'Jahr') {
          where = ' AND (YEAR(clients.birthday) = ' + self.searchYear + ' OR  YEAR(clients.partner_birthday) = ' + self.searchYear + ')';
          if (self.searchMonth !== 'Monat') {
            where += ' AND (MONTH(clients.birthday) = ' + (self.month.indexOf(self.searchMonth) + 1) + ' OR  MONTH(clients.partner_birthday) = ' + (self.month.indexOf(self.searchMonth) + 1) + ')';
          }
        }
        this.doPost({
          userdata: self.options.user, data: {
            eventId: self.tableData[0].eventId ? self.tableData[0].eventId : null,
            where: self.search ? where + " AND (clients.id like '%" + self.search + "%' or clients.firstname like '%" + self.search + "%' or clients.lastname like '%" + self.search + "%' or clients.email like '%" + self.search + "%' or clients.address like '%" + self.search + "%' or clients.phone like '%" + self.search + "%' or clients.birthday like '%" + self.search + "%' or clients.partner_birthday like '%" + self.search + "%' or clients.company like '%" + self.search + "%') " : where,
            sort: (self.currentSort === 'birthday' ? 'day(clients.birthday)' : 'clients.' + self.currentSort) + ' ' + self.currentSortOrder,
          }
        }, self.clientSource, async function (res) {
          if (res.data.status === 'error') {
            self.help.log(self.$t(res.msg), false, true);
          } else {
            if (res.data.data && (typeof res.data.data === 'object' || Array.isArray(res.data.data))) {
              self.responseToTableData(res.data.data, self.cols).then(values => {
                self.searched = values.slice(0, 100);
                self.options.isUploading = false;
                if (self.isClients) {
                  for (let i = 0; i < self.searched.length; i++) {
                    self.searched[i].tools = '<span class="list_check_icons"><i class="' + (self.searched[i].webuser ? 'green' : 'red') + '"><span></span></i><i class="' + (self.searched[i].piwik_token && self.searched[i].piwik_id ? 'green' : 'red') + '"><span></span></i></span>'
                  }
                }
              })
            }
          }
        });
      } else {
        if (this.title !== 'Auswertung') {
          self.tableData = self.tableData.sort(function (a, b) {
            const sortBy = self.currentSort;
            if ((a[sortBy] || a[sortBy] === 0) && (b[sortBy] || b[sortBy] === 0) && self.currentSortOrder === "desc") {
              if (!isNaN(parseFloat(a[sortBy])) && isFinite(a[sortBy])) {
                return a[sortBy] > b[sortBy] ? -1 : 0
              } else {
                return a[sortBy].localeCompare(b[sortBy])
              }
            } else if ((b[sortBy] || b[sortBy] === 0)) {
              if (!isNaN(parseFloat(b[sortBy])) && isFinite(b[sortBy])) {
                return b[sortBy] > a[sortBy] ? -1 : 0
              } else {
                return b[sortBy].localeCompare(a[sortBy])
              }
            }
          })
          self.searched = self.tableData.slice(0, 100);
          return true;
        } else {
          self.tableData = self.tableData.sort(function (a, b) {
            const sortBy = self.currentSort;
            if ((a[sortBy] || a[sortBy] === 0) && (b[sortBy] || b[sortBy] === 0)) {
              if (self.currentSortOrder === "desc") {
                if (!isNaN(parseFloat(a[sortBy])) && isFinite(a[sortBy])) {
                  return b[sortBy] - a[sortBy];
                } else {
                  return b[sortBy].localeCompare(a[sortBy]);
                }
              } else {
                if (!isNaN(parseFloat(a[sortBy])) && isFinite(a[sortBy])) {
                  return a[sortBy] - b[sortBy];
                } else {
                  return a[sortBy].localeCompare(b[sortBy]);
                }
              }
            }
            return 0;
          });
          self.searched = self.tableData.slice(0, 100);
          return true;
        }
      }
    },
    clearSearch() {
      this.search = null;
      this.clearSearchResults();
    },
    clearSearchResults() {
      let moreDataBtn = document.getElementById("moreData");
      if (moreDataBtn) moreDataBtn.disabled = false;
      let lessDataBtn = document.getElementById("lessData");
      if (lessDataBtn) lessDataBtn.disabled = true;

      if (this.options.currentRoute === 'Trips') {
        sessionStorage.removeItem("trip_search");
        sessionStorage.removeItem("trip_state");
      }

      // Reset searched to the same state as initial data load
      const src = this.originalTableData || this.tableData;
      if (src && src.length > 0) {
        this.searched = src.slice(0, this.defaultCount || this.options.defaultCount || 200);
      }
      this.dataLoaded = 1;
    },
    /**
     * Relevance-ranked POI search.
     *
     * Field priority: name > city > state > country, then the long free-text
     * fields as a weak fallback so they still find things but can never outrank
     * a name hit. Within a field, an exact match beats a prefix, which beats a
     * word-start, which beats a loose substring — that's what puts the POI
     * actually called "Sydney" above "TTP Sydney Hills Holiday Park".
     *
     * id and coordinate are numeric, so they only match exact/prefix; a loose
     * substring there would make typing "5" drag in half the table.
     */
    searchPois(pois, search) {
      const q = String(search || '').trim().toLowerCase();
      if (!q) return pois;

      // field -> weight (name dominates, free text is a tiebreaker at best)
      const TEXT_FIELDS = [
        ['name', 1000],
        ['city', 400],
        ['state', 200],
        ['country', 100],
        ['address_line_1', 30],
        ['address_line_2', 30],
        ['teaser', 10],
        ['description', 5],
        ['practical_infos', 5],
      ];
      const NUM_FIELDS = [['id', 800], ['coordinate', 60]];

      const scored = [];
      for (const poi of pois) {
        let score = 0;

        for (const [field, weight] of TEXT_FIELDS) {
          // never assume the column is present/non-null — one null would
          // otherwise throw and kill the whole search
          const v = String(poi[field] ?? '').toLowerCase();
          if (!v) continue;
          const q1 = this.poiMatchQuality(v, q);
          if (q1) score += weight * q1;
        }

        for (const [field, weight] of NUM_FIELDS) {
          const v = String(poi[field] ?? '').toLowerCase();
          if (!v) continue;
          if (v === q) score += weight * 4;
          else if (v.startsWith(q)) score += weight * 2;
        }

        if (score > 0) scored.push({ poi, score });
      }

      // highest score first; stable tiebreak on name so order never jitters
      scored.sort((a, b) =>
        b.score - a.score ||
        String(a.poi.name ?? '').localeCompare(String(b.poi.name ?? ''))
      );

      return scored.map(s => s.poi);
    },

    /** 4 = exact, 3 = prefix, 2 = starts a word, 1 = substring, 0 = no match. */
    poiMatchQuality(value, q) {
      if (value === q) return 4;
      if (value.startsWith(q)) return 3;
      const i = value.indexOf(q);
      if (i === -1) return 0;
      // does the hit begin at a word boundary?
      return /[\s,.\-/(]/.test(value.charAt(i - 1)) ? 2 : 1;
    },

    searchThis() {
      this.saveCurrentState()
      if (!this.search || this.search.trim() === '') {
        this.clearSearchResults();
        return;
      }
      let moreDataBtn = document.getElementById("moreData")
      if (moreDataBtn) {
        document.getElementById("moreData").disabled = true;
      }
      let lessDataBtn = document.getElementById("lessData")
      if (lessDataBtn) {
        document.getElementById("lessData").disabled = false;
      }
      if (this.options.currentRoute === 'POI') {
        if (!this.originalTableData) {
          this.originalTableData = this.tableData.slice();
        }
        if (this.search === '' || this.search === null) {
          this.searched = this.originalTableData
        } else {
          this.searched = this.searchPois(this.originalTableData, this.search);
        }
      } else {
        let self = this;
        self.dataLoaded = 1;
        if (self.serverside) {
          self.isSearching = true;
          let where = '';
          if ((self.searchMonth || self.searchMonth === 0) && self.searchMonth !== 'Monat') {
            where = ' AND (MONTH(clients.birthday) = ' + (self.month.indexOf(self.searchMonth) + 1) + ' OR  MONTH(clients.partner_birthday) = ' + (self.month.indexOf(self.searchMonth) + 1) + ')';
            if (self.searchYear !== 'Jahr') {
              where += ' AND YEAR(clients.birthday) = ' + self.searchYear;
            }
          } else if (self.searchYear && self.searchYear !== 'Jahr') {
            where = ' AND (YEAR(clients.birthday) = ' + self.searchYear + ' OR  YEAR(clients.partner_birthday) = ' + self.searchYear + ')';
            if (self.searchMonth !== 'Monat') {
              where += ' AND (MONTH(clients.birthday) = ' + (self.month.indexOf(self.searchMonth) + 1) + ' OR  MONTH(clients.partner_birthday) = ' + (self.month.indexOf(self.searchMonth) + 1) + ')';
            }
          }
          this.doPost({
            userdata: self.options.user, data: {
              eventId: self.tableData[0].eventId ? self.tableData[0].eventId : null,
              where: where + " AND (clients.id like '%" + self.search + "%' or clients.firstname like '%" + self.search + "%' or clients.lastname like '%" + self.search + "%' or clients.email like '%" + self.search + "%' or clients.address like '%" + self.search + "%' or clients.phone like '%" + self.search + "%' or clients.company like '%" + self.search + "%' or clients.partner_firstname like '%" + self.search + "%' or clients.partner_lastname like '%" + self.search + "%' or clients.partner_email like '%" + self.search + "%') ",
            }
          }, self.clientSource, async function (res) {
            if (res.data.status === 'error') {
              self.help.log(self.$t(res.msg), false, true);
            } else {
              if (res.data.data && (typeof res.data.data === 'object' || Array.isArray(res.data.data))) {
                self.responseToTableData(res.data.data, self.cols).then(values => {
                  self.isSearching = false;
                  self.searched = values.slice(0, 100);
                })
              }
            }
          });
        } else {
          if (self.search !== "" && self.search != null) {
            if (this.options.currentRoute !== 'Trips') {
              self.searched = self.searchTable(self.tableData, self.search, self.hideCols);
            } else {
              self.searchDataForTrips();
            }
          }
        }
        let lessDataBtn2 = document.getElementById("lessData")
        if (lessDataBtn2) {
          document.getElementById("lessData").disabled = false;
        }
      }
    },
    parseSearchInput(rawSearch) {
      const parts = rawSearch.split(',').map(p => p.trim()).filter(p => p.length > 0);
      const result = { textParts: [], dates: [], dateRanges: [] };

      for (const part of parts) {
        // Check for date range: "4 Sep 2026 - 14 Sep 2026" or "04/09/2026 - 14/09/2026"
        const rangeSep = part.match(/^(.+?)\s*-\s*(.+)$/);
        if (rangeSep) {
          const from = moment(rangeSep[1].trim(), this.dateFormats(), true);
          const to = moment(rangeSep[2].trim(), this.dateFormats(), true);
          if (from.isValid() && to.isValid()) {
            result.dateRanges.push({
              from: from.format('YYYY-MM-DD'),
              to: to.format('YYYY-MM-DD')
            });
            continue;
          }
        }
        // Check for single date
        const singleDate = moment(part, this.dateFormats(), true);
        if (singleDate.isValid()) {
          result.dates.push(singleDate.format('YYYY-MM-DD'));
          continue;
        }
        // Otherwise it's a text search term
        result.textParts.push(part);
      }
      return result;
    },
    dateFormats() {
      return [
        'DD MMM YYYY',
        'D MMM YYYY',
        'DD MMMM YYYY',
        'D MMMM YYYY',
        'DD/MM/YYYY',
        'D/M/YYYY',
        'DD.MM.YYYY',
        'D.M.YYYY',
        'DD-MM-YYYY',
        'YYYY-MM-DD',
      ];
    },
    async searchDataForTrips() {
      await this.getAllBrandings();
      let self = this;
      self.isLoaded = false;
      self.isSearching = true;
      self.searched = [];
      const parsed = self.parseSearchInput(self.search);

      await this.doPost({
        userdata: self.options.user, data: {
          search: parsed.textParts,
          dates: parsed.dates,
          dateRanges: parsed.dateRanges,
        }
      }, 'searchAllTrips', function (res) {
        if (res.data.status === 'error') {
          self.help.log(self.$t(res.msg), false, true);
        } else {
          if (res.data.data && (typeof res.data.data === 'object' || Array.isArray(res.data.data))) {
            self.responseToTableData(res.data.data, self.cols).then(values => {
              self.trips = values;
              const count = self.trips.length;
              for (let i = 0; i < count; i++) {
                self.trips[i].trip_date = moment(self.trips[i].date_start).format('DD MMM YYYY') + ' - ' + moment(self.trips[i].date_end).format('DD MMM YYYY')
                if (self.trips[i].Branding === "" || self.trips[i].Branding === "null" || self.trips[i].Branding == null) {
                  self.trips[i].Branding = "---"
                }
                self.matchedBrand.forEach(matchBrand => {
                  if (matchBrand.name === self.trips[i].Branding) {
                    self.searched.push(self.trips[i])
                  }
                })
              }
              self.customOrderAfterMoreData();
            })
          }
        }
        self.isSearching = false;
      })
    },
    async getAllBrandings() {
      this.brandings = [];
      this.allowedUserBranding = [];
      let self = this;
      await self.doPost({}, 'getAllBranding', function (res) {
        if (res.data.status === 'error') {
          self.help.log(self.$t(res.msg), false, true);
        } else {
          let result = res.data.data;
          for (let i = 0; i < result.length; i++) {
            self.brandings.push(result[i])
          }
        }
      });
      self.allowedUserBranding = JSON.parse(self.options.user.brandings);
      this.filterBrandings();
    },
    filterBrandings() {
      this.matchedBrand = [];
      this.brandings.forEach(branding => {
        let allowed = this.allowedUserBranding.find(brand => brand === branding.id)
        if (allowed) {
          let brandDetails = {
            name: branding.adresse,
            brandingID: branding.id
          }
          this.matchedBrand.push(brandDetails);
        }
      });
    },
    rmvData() {
      sessionStorage.removeItem("trip_count")
      sessionStorage.removeItem("more_data_number")
      location.reload()
    },
    async addData() {
      if (this.options.currentRoute === 'POI') {
        let actualLength = this.searched.length
        let moreDataUntil = actualLength + this.options.defaultCount > this.tableData.length ? this.tableData.length : actualLength + this.options.defaultCount
        for (let index = actualLength; index < moreDataUntil; index++) {
          this.searched.push(this.tableData[index])
        }
      } else {
        let self = this;
        if (self.serverside) {
          self.options.isUploading = true;
          let where = '';
          if ((self.searchMonth || self.searchMonth === 0) && self.searchMonth !== 'Monat') {
            where = ' AND (MONTH(clients.birthday) = ' + (self.month.indexOf(self.searchMonth) + 1) + ' OR  MONTH(clients.partner_birthday) = ' + (self.month.indexOf(self.searchMonth) + 1) + ')';
            if (self.searchYear !== 'Jahr') {
              where += ' AND YEAR(clients.birthday) = ' + self.searchYear;
            }
          } else if (self.searchYear && self.searchYear !== 'Jahr') {
            where = ' AND (YEAR(clients.birthday) = ' + self.searchYear + ' OR  YEAR(clients.partner_birthday) = ' + self.searchYear + ')';
            if (self.searchMonth !== 'Monat') {
              where += ' AND (MONTH(clients.birthday) = ' + (self.month.indexOf(self.searchMonth) + 1) + ' OR  MONTH(clients.partner_birthday) = ' + (self.month.indexOf(self.searchMonth) + 1) + ')';
            }
          }
          await this.doPost({
            userdata: self.options.user, data: {
              eventId: self.tableData[0].eventId ? self.tableData[0].eventId : null,
              where: self.search ? where + " AND (clients.id like '%" + self.search + "%' or clients.firstname like '%" + self.search + "%' or clients.lastname like '%" + self.search + "%' or clients.email like '%" + self.search + "%' or clients.address like '%" + self.search + "%' or clients.phone like '%" + self.search + "%' or clients.company like '%" + self.search + "%') " : where,
              limit: ((self.dataLoaded) * 100) + ',' + (100),
              sort: (((self.searchMonth || self.searchMonth === 0) && self.searchMonth !== 'Monat') || (self.searchYear && self.searchYear !== 'Jahr')) ? 'day(clients.birthday) ASC' : (self.currentSort && self.currentSortOrder ? 'clients.' + self.currentSort + ' ' + self.currentSortOrder : null),
            }
          }, self.clientSource, async function (res) {
            if (res.data.status === 'error') {
              self.help.log(self.$t(res.msg), false, true);
            } else {
              if (res.data.data && (typeof res.data.data === 'object' || Array.isArray(res.data.data))) {
                self.responseToTableData(res.data.data, self.cols).then(values => {
                  self.searched.push(...values);
                  self.options.isUploading = false;
                })
              }
            }
          });
        } else {
          let sourceCall = self?.tripsSource ? self.tripsSource : '';
          if (this.options.currentRoute !== 'Trips') {
            sourceCall = 'default';
          }
          switch (sourceCall) {
            case 'getAllTrips':
              self.saveCurrentState()
              await self.getAllTripsMore();
              break;
            default:
              self.searched.push(...self.tableData.slice((self.dataLoaded * self.tableLength), ((self.dataLoaded + 1) * self.tableLength)));
              break;
          }
        }
      }
      this.checklessDataButton();
      self.dataLoaded++;
    },
    saveCurrentState() {
      if (this.options.currentRoute !== 'Trips') return;
      sessionStorage.setItem("trip_state", true)
      if (this.search === null) {
        sessionStorage.setItem("trip_search", "")
      } else {
        sessionStorage.setItem("trip_search", this.search)
      }
    },
    loadCurrentState() {
      const state_changed = sessionStorage.getItem("trip_state")
      const trip_search = sessionStorage.getItem("trip_search")
      if (state_changed && this.options.currentRoute === 'Trips') {
        if (trip_search && trip_search.trim() !== '') {
          this.search = trip_search
          this.searchThis()
        }
      }
    },
    async getAllTripsMore() {
      let count = this.options.defaultCount
      let countFrom = this.searched.length
      this.showTripCount = true
      sessionStorage.setItem("trip_count", countFrom)
      let self = this;
      self.isLoaded = false;
      self.options.isUploading = true;
      await this.doPost({
        userdata: self.options.user, data: {
          countFrom: countFrom,
          count: count,
        }
      }, 'getAllTrips', async res => {
        if (res.data.status === 'error') {
          self.help.log(self.$t(res.msg), false, true);
        } else {
          if (res.data.data && (typeof res.data.data === 'object' || Array.isArray(res.data.data))) {
            self.responseToTableData(res.data.data, self.cols).then(values => {
              self.trips = values;
              const count = self.trips.length;
              for (let i = 0; i < count; i++) {
                self.trips[i].trip_date = moment(self.trips[i].date_start).format('DD MMM YYYY') + ' - ' + moment(self.trips[i].date_end).format('DD MMM YYYY')
                if (self.trips[i].Branding === "" || self.trips[i].Branding === "null" || self.trips[i].Branding == null) {
                  self.trips[i].Branding = "---"
                }
                self.searched.push(self.trips[i])
              }
              self.tripCount = self.searched.length
              sessionStorage.setItem("more_data_number", self.searched.length)
              self.showTripCount = true;
            })
          }
        }
        self.options.isUploading = false;
      })
      await self.customOrderAfterMoreData();
    },
    async customOrderAfterMoreData() {
      if (this.currentSort && this.currentSortOrder) {
        this.searched.sort((a, b) => {
          let comparison = 0;
          if (a[this.currentSort] > b[this.currentSort]) {
            comparison = 1;
          } else if (a[this.currentSort] < b[this.currentSort]) {
            comparison = -1;
          }
          return this.currentSortOrder === 'desc' ? comparison : comparison * -1;
        });
      }
    },
    newElement() {
      this.buttonAction === 'User' ? this.options['currentForm' + this.buttonAction] = null : this.buttonAction === 'Invoice' ? this.clearInvoice : this.options['current' + this.buttonAction] = null;
      this.options.currentTrip = this.buttonAction === 'ImportTrip' ? null : this.options.currentTrip;
      this.options['show' + this.buttonAction + 'Form'] = true;
    },
    editUser(user) {
      this.options.currentFormUser = user;
      this.options.userFormEditable = true;
      this.options.showUserForm = true;
    },
    editPOI(poi) {
      this.options.currentFormPOI = poi;
      this.options.POIFormEditable = true;
      this.options.showPOIForm = true;
    },
    editLink(item) {
      this.options.currentItem = item;
      this.options.showEditPassolutionForm = true;
    },
    async deleteLink(item) {
      this.itemToDelete = item;
      this.showDeleteConfirmation = true;
    },
    async confirmDeleteLink(item) {
      await this.doPost({ item: item }, 'passolution/delete', async (res) => {
        window.location.reload();
      });
    },
    cancelDeleteLink() {
      this.itemToDelete = null;
      this.showDeleteConfirmation = false;
    },
    addKommentar(trip) {
      this.localCurrentTrip = trip;
      this.options.showaddKommentarForm = true;
    },
    editSupplier(supplier) {
      this.options.currentSupplier = supplier;
      this.options.showSuppliersForm = true;
    },
    editHello(trip) {
      this.localCurrentTrip = trip;
      this.options.showEditHelloForm = true;
    },
    reviewTrip(trip) {
      window.open(process.env.VUE_APP_CLIENT_URL + "/angebot?trip=" + trip.nezasa_id + "&token=" + this.options.user.token, "_blank");
    },
    // Customer's perspective: the link WITHOUT the agent token (same link the
    // access-data e-mail carries), so whoever opens it gets the customer login.
    clientOfferLink(trip) {
      return process.env.VUE_APP_CLIENT_URL + "/angebot?trip=" + encodeURIComponent(trip.nezasa_id);
    },
    copyNezasaId(id) {
      if (!id) return;
      navigator.clipboard.writeText(id);
      this.copiedNezasaId = id;
      clearTimeout(this.copiedNezasaTimer);
      this.copiedNezasaTimer = setTimeout(() => { this.copiedNezasaId = null; }, 3500);
    },
    copyClientOfferLink(trip) {
      if (!trip || !trip.nezasa_id) return;
      navigator.clipboard.writeText(this.clientOfferLink(trip));
      // confirmation state for this row only, auto-reverts after 3.5 s
      this.copiedOfferId = trip.offer_id;
      clearTimeout(this.copiedOfferTimer);
      this.copiedOfferTimer = setTimeout(() => { this.copiedOfferId = null; }, 3500);
    },
    loginCodeTooltip(trip) {
      const code = trip && trip.loginCode ? trip.loginCode : '---';
      return `${this.options.Lang.login_code}: ${code}`;
    },
    uploadData(trip) {
      this.localCurrentTrip = trip;
      this.options.showUploadPdfForm = true;
    },
    updateTrip(trip) {
      this.localCurrentTrip = { ...trip, isReimport: true };
      this.options.showImportTripForm = true;
    },
    editClient(client) {
      let self = this;
      self.doPost({
        userdata: self.options.user,
        data: client.id,
      }, 'getClientById', function (res) {
        if (res.data.status === 'error') {
          self.help.log(self.$t(res.msg), false, true);
        } else {
          self.options.currentClient = res.data.data[0];
          self.options.clientFormEditable = true;
          self.options.showClientForm = true;
        }
      });
    },
    archivTrip(trip) {
      let self = this;
      this.doPost({ userdata: self.options.user, data: trip.offer_id }, 'archivTripById', function (res) {
        if (res.data.status === 'error') {
          self.help.log(self.$t(res.msg), false, true);
        } else {
          self.options.showSuccess = true;
          self.$emit('updateData', {});
        }
      });
    },
    uploadFirstImage(trip) {
      this.localCurrentTrip = trip;
      this.options.showFirstImageForm = true;
    },
    archivSupplier(supplier) {
      let self = this;
      this.doPost({ userdata: self.options.user, data: supplier.id }, 'archivSupplierById', function (res) {
        if (res.data.status === 'error') {
          self.help.log(self.$t(res.msg), false, true);
        } else {
          self.options.showSuccess = true;
          self.$emit('updateData', {});
        }
      });
    },
    customerLogin(trip) {
      this.localCurrentTrip = trip;
      this.options.showCustomerLoginForm = true;
    },
    unArchivSupplier(supplier) {
      let self = this;
      this.doPost({ userdata: self.options.user, data: supplier.id }, 'restoreSupplierById', function (res) {
        if (res.data.status === 'error') {
          self.help.log(self.$t(res.msg), false, true);
        } else {
          self.options.showSuccess = true;
          self.$emit('updateData', {});
        }
      });
    },
    unArchivTrip(trip) {
      let self = this;
      this.doPost({ userdata: self.options.user, data: trip.offer_id }, 'restoreTripById', function (res) {
        if (res.data.status === 'error') {
          self.help.log(self.$t(res.msg), false, true);
        } else {
          self.options.showSuccess = true;
          self.$emit('updateData', {});
        }
      });
    },
    sendSupplier(trip) {
      this.localCurrentTrip = trip;
      this.options.tripFormEditable = true;
      this.options.showSendEmailToSupplierForm = true;
    },
    archivClient(client) {
      let self = this;
      this.doPost({ userdata: self.options.user, data: client.id }, 'archivClientById', function (res) {
        if (res.data.status === 'error') {
          self.help.log(self.$t(res.msg), false, true);
        } else {
          self.options.showSuccess = true;
          self.$emit('updateData', {});
        }
      });
    },
    addClient(client, event) {
      if (event.target.innerHTML === 'person_add_alt') {
        this.clientToAdd = {};
        event.target.innerHTML = 'check_circle_outline';
        event.target.classList.add('checked');
        this.clientToAdd[client.id] = {
          amount: 1,
          amountGuest: 0,
          client: client
        }
        client.showhelper = 1;
      } else {
        event.target.innerHTML = 'person_add_alt';
        event.target.classList.remove('checked');
        client.showhelper = 0;
        delete this.clientToAdd[client.id];
      }
    },
    tableAction(action, item, event) {
      switch (action) {
        case 'addClient':
          this.addClient(item, event);
          break;
        case 'editClient':
          this.editClient(item, event);
          break;
        case 'archivClient':
          this.archivClient(item, event);
          break;
        case 'archivTrip':
          this.archivTrip(item, event);
          break;
        case 'archivSupplier':
          this.archivSupplier(item, event);
          break;
        case 'unArchivSupplier':
          this.unArchivSupplier(item, event);
          break;
        case 'unArchivTrip':
          this.unArchivTrip(item, event);
          break;
        case 'editUser':
          this.editUser(item, event);
          break;
        case 'addKommentar':
          this.addKommentar(item, event);
          break;
        case 'sendSupplier':
          this.sendSupplier(item, event);
          break;
        case 'editSupplier':
          this.editSupplier(item, event);
          break;
        case 'updateTrip':
          this.updateTrip(item, event);
          break;
        case 'reviewTrip':
          this.reviewTrip(item, event);
          break;
        case 'editHello':
          this.editHello(item, event);
          break;
        case 'uploadData':
          this.uploadData(item, event);
          break;
        case 'sendDataToUser':
          break;
        case 'downloadTrip':
          break;
        case 'uploadFirstImage':
          this.uploadFirstImage(item, event);
          break;
        case 'customerLogin':
          this.customerLogin(item, event);
          break;
        case 'editPOI':
          this.editPOI(item, event);
          break;
        case 'editPassolutionLink':
          this.editLink(item, event);
          break;
        case 'deletePassolutionLink':
          this.deleteLink(item, event);
          break;
        default:
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.simple-list-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
  max-width: 100%;
  background: transparent;
}
.search-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.25);
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}


/* TOOLBAR */
.table-toolbar {
  flex-shrink: 0;
  padding: 2px 20px 32px 20px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
  background: transparent;
  position: relative;
  z-index: 30;
}
.toolbar-start {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1 1 auto;
}
.sl-title {
  font-size: 28px;
  font-weight: 500;
  margin: 0;
  line-height: 1.2;
  color: #333;
}
.toolbar-end {
  display: flex;
  align-items: center;
  gap: 8px;
}
.toolbar-search {
  display: flex;
  align-items: center;
  flex-grow: 1;
  max-width: 600px;
  gap: 4px;
}

.search-result-count {
  font-size: 12px;
  color: #667085;
  white-space: nowrap;
  margin-right: 8px;
  flex-shrink: 0;
  min-width: 90px;
  text-align: right;
}
.search-bar {
  display: flex;
  align-items: center;
  width: 100%;
  background: #fff;
  border: 1px solid #d0d5dd;
  border-radius: 8px;
  padding: 0 12px;
  height: 38px;
  transition: border-color 0.2s, box-shadow 0.2s;
}
.search-bar:focus-within {
  border-color: #448aff;
  box-shadow: 0 0 0 3px rgba(68, 138, 255, 0.15);
}
.search-bar-icon {
  color: #98a2b3 !important;
  font-size: 20px !important;
  margin-right: 8px;
  flex-shrink: 0;
}
.search-bar-input {
  border: none;
  outline: none;
  background: transparent;
  font-size: 14px;
  color: #333;
  flex: 1;
  height: 100%;
  font-family: inherit;
}
.search-bar-input::placeholder {
  color: #98a2b3;
}
.search-bar-clear {
  color: #98a2b3 !important;
  font-size: 18px !important;
  cursor: pointer;
  flex-shrink: 0;
  margin-left: 4px;
  transition: color 0.15s;
}
.search-bar-clear:hover {
  color: #555 !important;
}
.search-help-wrapper {
  position: relative;
  flex-shrink: 0;
}
.search-help-icon {
  color: #98a2b3 !important;
  font-size: 22px !important;
  cursor: pointer;
  transition: color 0.15s;
}
.search-help-icon:hover {
  color: #448aff !important;
}
.search-help-popup {
  position: absolute;
  top: 36px;
  right: 0;
  width: 420px;
  background: #fff;
  border: 1px solid #d0d5dd;
  border-radius: 10px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  z-index: 200;
  overflow: hidden;
}
.search-help-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  background: #f9fafb;
  border-bottom: 1px solid #e5e7eb;
  font-weight: 600;
  font-size: 14px;
  color: #333;
}
.search-help-close {
  color: #98a2b3 !important;
  font-size: 18px !important;
  cursor: pointer;
}
.search-help-close:hover {
  color: #555 !important;
}
.search-help-body {
  padding: 14px 16px;
  font-size: 13px;
  color: #555;
  line-height: 1.5;
}
.search-help-body p {
  margin: 0 0 10px 0;
}
.search-help-table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 10px;
}
.search-help-table tr {
  border-bottom: 1px solid #f0f0f0;
}
.search-help-table tr:last-child {
  border-bottom: none;
}
.search-help-table td {
  padding: 6px 8px;
  vertical-align: top;
  font-size: 13px;
}
.search-help-example {
  font-family: monospace;
  font-size: 12px;
  color: #448aff;
  white-space: nowrap;
  font-weight: 500;
  min-width: 200px;
}
.search-help-formats {
  font-size: 12px;
  color: #98a2b3;
  margin-bottom: 0 !important;
}
.toolbar-auswertung {
  width: 100%;
  display: flex;
  gap: 15px;
  align-items: center;
  flex-wrap: nowrap;
}

/* TABLE CONTAINER - only scrollable area, never exceeds screen */
.table-container {
  flex: 1 1 auto;
  overflow-y: auto;
  overflow-x: hidden;
  position: relative;
  background: #fff;
  border-radius: 8px 8px 0 0;
  box-shadow: 0 1px 5px rgba(0,0,0,0.1), 0 2px 2px rgba(0,0,0,0.06);
}

.table-empty {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  color: #999;
  font-size: 16px;
}

/* THE TABLE - always fits within container, no horizontal scroll */
.sl-table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
}

/* STICKY HEADER */
.sl-table thead {
  position: sticky;
  top: 0;
  z-index: 20;
}
.sl-th {
  background: #e0e8f3;
  border-bottom: 2px solid #c8d4e8;
  padding: 8px 4px;
  text-align: center;
  font-size: 12px;
  font-weight: 600;
  color: #555;
  cursor: pointer;
  user-select: none;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  position: sticky;
  top: 0;
  z-index: 20;
  transition: width 0.35s ease;
}
.sl-th:first-child,
.sl-td:first-child {
  width: 6%;
}
.sl-th:first-child {
  border-top-left-radius: 8px;
}
.sl-th:last-child {
  border-top-right-radius: 8px;
}
.sl-th:hover {
  background: #d4dded;
}
.sl-th.sl-sorted {
  color: #1976d2;
}
.sl-th-label {
  display: inline-flex;
  align-items: center;
  gap: 3px;
}
.sl-sort-icon {
  font-size: 9px;
  opacity: 0.7;
}

/* ACTIONS HEADER - wide when open, narrow when collapsed */
.sl-th-actions {
  width: 25%;
  cursor: default;
  transition: width 0.35s ease;
}
.sl-th-actions.sl-th-actions-few {
  width: 80px;
}
.sl-th-actions.sl-th-actions-collapsed {
  width: 50px;
  min-width: 50px;
  overflow: visible;
}
.sl-th-actions:hover {
  background: #e0e8f3;
}
.actions-header-content {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  white-space: nowrap;
}
.actions-header-text {
  transition: opacity 0.25s ease, max-width 0.3s ease;
  max-width: 120px;
  overflow: hidden;
  display: inline-block;
  opacity: 1;
}
.actions-header-text-hidden {
  opacity: 0;
  max-width: 0;
}
.actions-toggle-btn {
  margin: 0 !important;
  min-width: 24px !important;
  width: 24px !important;
  height: 24px !important;
}
.actions-toggle-btn .md-icon {
  font-size: 16px !important;
}

/* TABLE ROWS */
.sl-row {
  border-bottom: 1px solid #eee;
  transition: background-color 0.15s;
}
.sl-row:hover {
  background-color: #E0E8F3 !important;
}
.sl-row-menu-open {
  position: relative;
  z-index: 30;
}
.sl-td {
  padding: 6px 4px;
  text-align: center;
  font-size: 13px;
  color: #333;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  transition: width 0.35s ease;
}

/* ACTION COLUMN - wide when open, narrow when collapsed */
.sl-td-actions {
  width: 25%;
  overflow: visible;
  position: relative;
  transition: width 0.35s ease;
}
.sl-td-actions.sl-td-actions-few {
  width: 80px;
}
.sl-td-actions.sl-td-actions-collapsed {
  width: 50px;
  min-width: 50px;
}

/* EXPANDED ACTIONS (default) */
.actions-expanded {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0;
  flex-wrap: nowrap;
  transition: opacity 0.25s ease, max-height 0.3s ease;
  opacity: 1;
  max-height: 60px;
  overflow: hidden;
}
.actions-expanded.actions-content-hidden {
  opacity: 0;
  max-height: 0;
  pointer-events: none;
}
.action-inline-item {
  display: inline-flex;
  align-items: center;
  cursor: pointer;
}
.action-inline-item ::v-deep .md-icon-button,
.action-inline-item ::v-deep .md-button {
  margin: 0 2px !important;
  min-width: 32px !important;
  width: 32px !important;
  height: 32px !important;
}
.action-inline-item ::v-deep .md-icon {
  font-size: 20px !important;
}
.action-inline-item.disabled {
  opacity: 0.3;
  pointer-events: none;
}
.action-text-icon {
  display: inline-block;
  color: lightgray;
  font-size: 22px;
  line-height: 32px;
}
.action-menu-wrapper {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  transition: opacity 0.25s ease 0.15s;
  opacity: 0;
  pointer-events: none;
}
.action-menu-wrapper.action-menu-visible {
  opacity: 1;
  pointer-events: auto;
}
.action-trigger {
  margin: 0 !important;
}

/* ACTION POPUP MENU */
.action-popup {
  position: absolute;
  right: 40px;
  top: 0;
  min-width: 180px;
  width: max-content;
  background: #fff;
  border-radius: 6px;
  box-shadow: 0 4px 16px rgba(0,0,0,0.15), 0 1px 4px rgba(0,0,0,0.1);
  z-index: 9999;
  padding: 6px 0;
}
.action-popup.action-popup-up {
  top: auto;
  bottom: 0;
}
.action-popup-header {
  padding: 6px 16px 4px;
  font-size: 12px;
  font-weight: 700;
  color: #000;
  border-bottom: 1px solid #eee;
  margin-bottom: 4px;
  text-align: left;
}
.action-popup-item {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
  padding: 8px 16px;
  cursor: pointer;
  font-size: 13px;
  color: #333;
  white-space: nowrap;
  transition: background 0.12s;
  text-align: left;
}
.action-popup-item:hover {
  background: #f0f4ff;
}
.action-popup-item.disabled {
  opacity: 0.4;
  pointer-events: none;
}
.action-popup-label {
  flex: 1;
}
.action-popup-text {
  font-size: 14px;
  color: #888;
}
.action-popup-icons {
  display: flex;
  gap: 2px;
}

/* MENU TRANSITION */
.menu-fade-enter-active,
.menu-fade-leave-active {
  transition: opacity 0.15s, transform 0.15s;
}
.menu-fade-enter,
.menu-fade-leave-to {
  opacity: 0;
  transform: translateY(-4px);
}

/* BOOKING STATE BARS */
.booking-bar-booked td:first-child,
.booking-bar-cancelled td:first-child,
.booking-bar-planning td:first-child {
  position: relative;
  overflow: visible;
}
.booking-bar-booked td:first-child::before,
.booking-bar-cancelled td:first-child::before,
.booking-bar-planning td:first-child::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 3px;
  border-radius: 0 999px 999px 0;
}
.booking-bar-booked td:first-child::before {
  background-color: #4caf50;
}
.booking-bar-cancelled td:first-child::before {
  background-color: #f44336;
}
.booking-bar-planning td:first-child::before {
  background-color: #ff9800;
}

/* BOOKING STATE BADGES */
.booking-state-badge {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;
  color: #fff;
}
.bs-booking-initiated { background-color: #90caf9; }
.bs-booking-inprogress { background-color: #42a5f5; }
.bs-booking-requested { background-color: #1e88e5; }
.bs-booking-completed { background-color: #4caf50; }
.bs-booking-failed { background-color: #e91e63; }
.bs-change-initiated { background-color: #ce93d8; }
.bs-change-inprogress { background-color: #ab47bc; }
.bs-change-requested { background-color: #8e24aa; }
.bs-change-completed { background-color: #00897b; }
.bs-cancel-initiated { background-color: #ffab91; }
.bs-cancel-inprogress { background-color: #ff7043; }
.bs-cancel-requested { background-color: #f4511e; }
.bs-cancel-completed { background-color: #d32f2f; }
.bs-cancelled { background-color: #b71c1c; }
.bs-planning { background-color: #ff9800; }
.bs-discarded { background-color: #9e9e9e; }
.bs-unknown { background-color: #757575; }

/* MISC */
.inline-svg svg {
  width: 1rem;
  height: 1rem;
  vertical-align: middle;
  fill: currentColor;
}
.svg-icon {
  width: 1.2rem;
  vertical-align: middle;
}
.svg-icon-green {
  filter: brightness(0) saturate(100%) invert(48%) sepia(79%) saturate(382%) hue-rotate(93deg) brightness(95%) contrast(92%);
}
.copy-icon-img {
  width: 12px;
  height: 12px;
  cursor: pointer;
  margin-left: 2px;
  opacity: 0.8;
  transition: 0.12s ease;
}
.copy-icon-img:hover {
  opacity: 0.5;
  color: #0094ff;
}
.nezasa-id-cell {
  display: flex;
  align-items: center;
  width: 100%;
}
/* Ang-Nr cell: "open in client view" icon (same SVG style as the copy icon) + id */
.offer-id-cell {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}
.offer-open-icon {
  width: 14px;
  height: 14px;
  cursor: pointer;
  opacity: 0.8;
  transition: 0.12s ease;
}
.offer-open-icon:hover {
  opacity: 0.5;
}
/* the green tick is drawn a bit larger than the icon it replaces; negative
   margins keep the cell from shifting */
.offer-open-icon--copied,
.copy-icon-img--copied {
  width: 16px;
  height: 16px;
  margin: -2px;
  cursor: default;
  opacity: 1;
}
/* copy icon <-> green tick: cross-fade with a small scale, both directions */
.offer-copy-enter-active,
.offer-copy-leave-active {
  transition: opacity 0.22s ease, transform 0.22s cubic-bezier(0.34, 1.56, 0.64, 1);
}
.offer-copy-enter,
.offer-copy-leave-to {
  opacity: 0;
  transform: scale(0.5);
}
.nezasa-id-cell .nezasa-id-text {
  flex: 1;
  text-align: center;
}
.nezasa-id-cell .copy-icon-img {
  flex-shrink: 0;
  margin-left: auto;
}
.nezasa-id-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.checkout-url-text {
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #1976d2;
  text-decoration: none;
}
.checkout-url-text:hover {
  text-decoration: underline;
}
.copy-icon-img.copy-animate {
  animation: pop 0.3s ease-out;
}
@keyframes pop {
  0% { transform: scale(1); }
  40% { transform: scale(1.5); }
  100% { transform: scale(1); }
}

.md-field {
  max-width: 300px;
}

@media screen and (max-width: 1401px) and (max-height: 1051px) {
  .sl-th {
    padding: 6px 3px;
    font-size: 11px;
  }
  .sl-td {
    padding: 5px 3px;
    font-size: 12px;
  }
}
</style>

<style lang="scss">
/* Unscoped: lock parent chain so only the table body scrolls, nothing else */
#backend_wrapper:has(.simple-list-wrapper) {
  height: 100vh;
  max-height: 100vh;
  overflow: hidden;
  box-sizing: border-box;
}
.content_section:has(.simple-list-wrapper) {
  height: 100%;
  overflow: hidden;
}
.md-app-content:has(.simple-list-wrapper) {
  overflow: hidden !important;
}
.md-app-content:has(.simple-list-wrapper) .content {
  height: 100%;
  overflow: hidden;
}
</style>
